import { NgModule } from '@angular/core';

import { LayoutRoutingModule } from './layout-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HttpsRequestInterceptor } from '../_services/interceptor.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
    imports: [
        LayoutRoutingModule,
        SharedModule,
    ],
    declarations: [],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true }
    ]
})

export class LayoutModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout.module.ts